module.exports = __webpack_public_path__ + "static/media/12.47e082b5.png";